import {SERVER_URL} from '../.config'; // http://localhost:8080/
import {getMatchResultsAsync} from '../actions/history';

export const CREATE_ACCOUNT_ASYNC = 'CREATE_ACCOUNT_ASYNC';
export const createAccountAsync = (payload)=> dispatch =>{
    console.log('CREATE_ACCOUNT_Async');
    fetch(`${SERVER_URL}users/newuser`, payload)
        .then(res => {
            console.log(res);
            if (!res.ok) {
                return Promise.reject(res.statusText);
            }
            return res.json();
        })
        .then(res=>{
            console.log(res)
        })
        .catch(err => {
                console.log(err);
            }
        )
};

export const CREATE_ACCOUNT_RESTORE_LOGIN = '';

export const LOGIN_ASYNC = 'LOGIN_ASYNC';
export const loginAsync = (gamertagCreds, passwordCreds, payload)=> dispatch =>{
    console.log('LOGIN_ASYNC');
    fetch(`${SERVER_URL}users/login/${gamertagCreds}`, payload)
        .then(res => {
            return res.json();
        })
        .then(json=>{
            console.log(json);
            if(json.length===0){
                dispatch(badUserOrPass());
            }
            else{
                console.log('json: '+ json[0].gamertag +', cred: '+ gamertagCreds +', json: '+ json[0].password +', cred: '+passwordCreds);
                if(json[0].gamertag===gamertagCreds && json[0].password===passwordCreds){
                    console.log('Storing data for '+json[0].gamertag);
                    dispatch(storeUserCreds(json));

                    // Dispatch Async for past matches. Dep on stored user uuid.
                    let payload={
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json"
                        },
                        method: 'GET'
                    };
                    dispatch(getMatchResultsAsync(payload, json[0].uuid));
                }
                else{
                    dispatch(badUserOrPass());
                }

            }
        })
        .catch(err => {
                console.log(err);
                console.warn('No user found.');
                dispatch(badUserOrPass());
            }
        );
};

export const BAD_USER_OR_PASS = 'BAD_USER_OR_PASS';
export const badUserOrPass = ()=>({
    type: BAD_USER_OR_PASS
});

export const STORE_USER_CREDS = 'STORE_USER_CREDS';
export const storeUserCreds = (jsonObj) => ({
    type: STORE_USER_CREDS,
    jsonObj
});

export const UPDATE_ACCOUNT_ASYNC = 'UPDATE_ACCOUNT_ASYNC';
export const updateAccountAsync = (payload, localPayload) => dispatch =>{
    console.log('UPDATE_ACCOUNT_ASYNC');
    fetch(`${SERVER_URL}users/updateuser`, payload)
        .then(res=>{
            console.log('Prepping to dispatch local user cred update...');
            if(res.ok){
                dispatch(updateAccountLocalStore(localPayload));
            }
        })
};

export const UPDATE_ACCOUNT_LOCAL_STORE = 'UPDATE_ACCOUNT_LOCAL_STORE';
export const updateAccountLocalStore = (asyncPayload) => ({
    type: UPDATE_ACCOUNT_LOCAL_STORE,
    asyncPayload
});

export const DELETE_ACCOUNT_ASYNC = 'DELETE_ACCOUNT';
export const deleteAccountAsync = (payload)=> dispatch =>{
    fetch(`${SERVER_URL}users/deleteuser`, payload)
        .then(res=>{
            if(res.ok){
                // Dispatch logout
                dispatch(logout());
            }
            else{
                return Promise.reject(res.statusText);
            }
        })
};

export const INIT_GAME_STATE = 'INIT_GAME_STATE';
export const initGameState = (setGameState)=>({
    type: INIT_GAME_STATE,
    setGameState
});

export const LOGOUT = 'LOGOUT';
export const logout = ()=> ({
    type: LOGOUT
});


// WEBPACK FOOTER //
// ./src/actions/user.js